<template>
    <RightSideBar 
        v-if="openModal"
        @close="$emit('close')"
        @submit="submit"
        :disabled-button="isLoading"
        submit="Export"
        cancel="Cancel"
        button-class="bg-dynamicBackBtn text-white"
    >
        <template v-slot:title>
            <div class="text-darkPurple flex gap-5 items-center">
                <div class="" @click="$emit('close')">
                    <icon icon-name="back_arrow" size="s" class="w-8 h-8 cursor-pointer rounded text-romanSilver"/>
                </div> Select employee fields to export
            </div>
        </template>
        <p class="font-normal text-sm text-darkPurple">
            Choose the employee information you want to include in the export file.
        </p>

        <div class="w-full mt-5">
            <div class="w-full flex justify-between items-center">
                <div>
                    <p class="font-black text-jet">Personal information</p>
                    <p></p>
                </div>
                <div class="cursor-pointer" @click="isPersonalInformation = !isPersonalInformation">
                    <icon :icon-name="isPersonalInformation ? 'chevronUp' : 'icon-arrow-down'" class="icon" size="xs"/>
                </div>
            </div>

            <div v-if="isPersonalInformation" class="w-full px-2 mt-4">
                <div v-if="personalInformation && Object.keys(personalInformation).length > 0"
                    class="w-full flex justify-between items-center"
                >
                    <p class="capitalize font-normal">Select All</p>
                    <checkbox v-model="isAllPersonalInformation" @change="selectAll('personalInformation')"
                        checkbox-size="height:16px; width:16px; cursor: pointer;" label-style="color:#333333"
                    />
                </div>
                <div class="w-full" v-for="(personal, key) in personalInformation" :key="key">
                    <div class="w-full flex justify-between items-center mt-3">
                        <p class="capitalize font-normal">{{  getKey(key) }}</p>
                        <checkbox v-model="personalInformation[key]"
                            checkbox-size="height:16px; width:16px; cursor: pointer;" label-style="color:#333333"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full mt-5">
            <div class="w-full flex justify-between items-center">
                <div>
                    <p class="font-black text-jet">Education & Certification</p>
                    <p></p>
                </div>
                <div class="cursor-pointer" @click="isEducationCertification = !isEducationCertification">
                    <icon :icon-name="isEducationCertification ? 'chevronUp' : 'icon-arrow-down'" class="icon" size="xs"/>
                </div>
            </div>

            <div v-if="isEducationCertification" class="w-full px-2 mt-4">
                <div v-if="educationAndCertification && Object.keys(educationAndCertification).length > 0"
                    class="w-full flex justify-between items-center"
                >
                    <p class="capitalize font-normal">Select All</p>
                    <checkbox v-model="isAllEducationCertification" @change="selectAll('educationAndCertification')"
                        checkbox-size="height:16px; width:16px; cursor: pointer;" label-style="color:#333333"
                    />
                </div>
                <div class="w-full" v-for="(value, key) in educationAndCertification" :key="key">
                    <div class="w-full flex justify-between items-center mt-3">
                        <p class="capitalize font-normal">{{  getKey(key) }}</p>
                        <checkbox v-model="educationAndCertification[key]"
                            checkbox-size="height:16px; width:16px; cursor: pointer;" label-style="color:#333333"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full mt-5">
            <div class="w-full flex justify-between items-center">
                <div>
                    <p class="font-black text-jet">Employment Details</p>
                    <p></p>
                </div>
                <div class="cursor-pointer" @click="isEmploymentDetails = !isEmploymentDetails">
                    <icon :icon-name="isEmploymentDetails ? 'chevronUp' : 'icon-arrow-down'" class="icon" size="xs"/>
                </div>
            </div>

            <div v-if="isEmploymentDetails" class="w-full px-2 mt-4">
                <div v-if="employmentDetails && Object.keys(employmentDetails).length > 0"
                    class="w-full flex justify-between items-center"
                >
                    <p class="capitalize font-normal">Select All</p>
                    <checkbox v-model="isAllEmploymentDetails" @change="selectAll('employmentDetails')"
                        checkbox-size="height:16px; width:16px; cursor: pointer;" label-style="color:#333333"
                    />
                </div>
                <div class="w-full" v-for="(value, key) in employmentDetails" :key="key">
                    <div class="w-full flex justify-between items-center mt-3">
                        <p class="capitalize font-normal">{{  getKey(key) }}</p>
                        <checkbox v-model="employmentDetails[key]"
                            checkbox-size="height:16px; width:16px; cursor: pointer;" label-style="color:#333333"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full mt-5">
            <div class="w-full flex justify-between items-center">
                <div>
                    <p class="font-black text-jet">Pay information</p>
                    <p></p>
                </div>
                <div class="cursor-pointer" @click="isPayInformation = !isPayInformation">
                    <icon :icon-name="isPayInformation ? 'chevronUp' : 'icon-arrow-down'" class="icon" size="xs"/>
                </div>
            </div>
            <div v-if="isPayInformation" class="w-full px-2 mt-4">
                <div v-if="payInformation && Object.keys(payInformation).length > 0"
                    class="w-full flex justify-between items-center"
                >
                    <p class="capitalize font-normal">Select All</p>
                    <checkbox v-model="isAllPayInformation" @change="selectAll('payInformation')"
                        checkbox-size="height:16px; width:16px; cursor: pointer;" label-style="color:#333333"
                    />
                </div>
                <div class="w-full" v-for="(value, key) in payInformation" :key="key">
                    <div class="w-full flex justify-between items-center mt-3">
                        <p class="capitalize font-normal">{{  getKey(key) }}</p>
                        <checkbox v-model="payInformation[key]"
                            checkbox-size="height:16px; width:16px; cursor: pointer;" label-style="color:#333333"
                        />
                    </div>
                </div>
            </div>
        </div>
    </RightSideBar>
</template>
<script>
export default {
    name: "ExportDirectory",
    components: {
        RightSideBar: () => import("@/components/RightSideBar"),
        Checkbox: () => import("@/components/Checkbox")
    },
    props: {
        openModal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            isPersonalInformation: true,
            isEducationCertification: true,
            isEmploymentDetails: false,
            isPayInformation: false,
            educationAndCertification: {}, 
            employmentDetails: {},
            payInformation: {},
            personalInformation: {},
            personalInfoKeyMap: {
                fname: 'First Name',
                mname: 'Middle Name',
                lname: 'Last Name',
                dob: 'Date of Birth'
            },
            isAllPersonalInformation: false,
            isAllEducationCertification: false,
            isAllPayInformation: false,
            isAllEmploymentDetails: false
        }
    },
    methods: {
        getKey(key) {
            return this.personalInfoKeyMap[key] || this.keyFormat(key)
        },
        keyFormat(key) {
            return key.replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase())
        },
        selectAll(type) {
            if (type === "personalInformation") {
                Object.keys(this.personalInformation).forEach(key => {
                    this.personalInformation[key] = this.isAllPersonalInformation
                })
            }
            if (type === "educationAndCertification") {
                Object.keys(this.educationAndCertification).forEach(key => {
                    this.educationAndCertification[key] = this.isAllEducationCertification
                })
            }
            if (type === "employmentDetails") {
                Object.keys(this.employmentDetails).forEach(key => {
                    this.employmentDetails[key] = this.isAllEmploymentDetails
                })
            }
            if (type === "payInformation") {
                Object.keys(this.payInformation).forEach(key => {
                    this.payInformation[key] = this.isAllPayInformation
                })
            }
        },
        async getExportAttributes(){
            try {
                const { data }  = await this.$_getExportAttributes();
                const { educationCertification, employmentDetails,
                        payInformation, personalInformation } = data.data
                this.educationAndCertification = educationCertification;
                this.employmentDetails = employmentDetails;
                this.payInformation = payInformation;
                this.personalInformation = personalInformation;
                
            } catch (error) {
                return this.$toasted.error("Erorr getting export attributes", {duration: 6000});
            }
        },
        async submit() {
            this.isLoading = true;
            const payload = {
                exportFields: {
                    personalInformation: this.personalInformation,
                    educationCertification: this.educationAndCertification,
                    employmentDetails: this.employmentDetails,
                    payInformation: this.payInformation
                }
            }
            try {
                const { data } = await this.$_postNewEmployeesExport(payload);
                const blob = new Blob([ data ], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `Employees_Details`;
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(link);
                this.isLoading = false;
                this.$emit('close')
                return this.$toasted.success("Directory successfully exported", {duration: 6000});
            } catch (error) {
                this.isLoading = false;
                return this.$toasted.error("Erorr exporting directory", {duration: 6000});
            }
        }
    },
    async mounted(){
        await this.getExportAttributes();
    }
};
</script>
<style scoped>
</style>